import _ from 'lodash';
import $ from 'jquery';

const blockProductCarousel = require('./blocks/product-carousel');

blockProductCarousel.frontend();

$('input[name=on_sale]').on('change', ev => {
  let target = ev.target;
  let checked = target.checked ? true : false;
  console.log(checked);
});